var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('w-tool-tip',{attrs:{"label":_vm.toolTipMessage,"size":_vm.tooltipSize,"color":_vm.tooltipColor,"position":_vm.tooltipPosition,"delay":_vm.tooltipDelay}},[_c('div',{class:_vm.classOfAvatar+' '+_vm.type+ ' ' + _vm.classOfSelected,style:(_vm.backgroundOfAvatar),on:{"click":_vm.onClick}})])
}
var staticRenderFns = []

export { render, staticRenderFns }